import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { apiLinks } from 'src/app/core/api-links/api-links';
import { LineItemData, ViewInvoice, ConsumerDetails, InvoiceDetails, MerchantDetails, getL2L3LineItemDetails, handleLineItemEmptyValues, getLineItemDetails } from 'src/app/core/model/invoice';
import { CommonService } from 'src/app/providers/common.service';
import html2canvas from 'html2canvas';
import { jsPDF } from "jspdf";
import { environment } from 'src/environments/environment';
import { isEmpty } from 'lodash';
import { Title } from '@angular/platform-browser';
import { Transaction } from 'src/app/core/model/transaction';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-view-invoice',
  templateUrl: './view-invoice.component.html',
  styleUrls: ['./view-invoice.component.scss'],
   providers: [
    MessageService,
]
})
export class ViewInvoiceComponent implements OnInit {

  constructor(private route: ActivatedRoute, public commonService: CommonService, public title: Title, private router: Router, private messageService: MessageService) {
    
  }

  @ViewChild('invoice') invoiceRef: ElementRef;

  invoiceId: string | null
  bannerImage = environment?.defaultLogo;
  isLoading: boolean = false
  details: ViewInvoice


  lineItemDetails: LineItemData[] = []
  cols = [
    { field: 'code', header: '#', width: '2.5%' },
    { field: 'productName', header: 'Name', width: '15%' },
    { field: 'unitCost', header: 'Price', width: '10%' },
    { field: 'quantity', header: 'Qty', width: '7.5%' },
    { field: 'discount', header: 'Disc', width: '10%' },
    { field: 'description', header: 'Description', width: '35%' },
    { field: 'totalTax', header: 'Tax', width: '10%' },
    { field: 'totalAmount', header: 'Sub Total', width: '12.5%' },

  ];

  totalAmount: number = 0
  totalTax: number = 0
  totalDiscount: number = 0
  shippingFee: number = 0
  paidChildInvoicesTotal: number = 0
  md: MerchantDetails
  cd: ConsumerDetails
  id: InvoiceDetails
  td: Transaction
  imageUrl = environment?.whitelabelLogoPath;
  private isOpenUrl:Boolean = window.location.href.split("/").indexOf("vi") !== -1;


  async ngOnInit() {
    this.isLoading = true
    this.title.setTitle('Invoice - IPOSpays')
      const localWhitelabelData = JSON.parse(localStorage.getItem('whitelabelResData'));
      if (localWhitelabelData) {
        this.title.setTitle(`Invoice -${localWhitelabelData?.tabName}`)
         this.bannerImage = `${this.imageUrl}/${localWhitelabelData?.logo_dashboard}`
      }
    this.invoiceId = this.route.snapshot.paramMap.get('id');
    try {
      const response = await this.commonService.getCommonHttpClientQueryParams(this.isOpenUrl ? `${apiLinks.receipt.viewReceiptNoAuthBackend}/${this.invoiceId}` : apiLinks.getInvoiceById, this.isOpenUrl ? {} : { id: this.invoiceId }).toPromise()
      this.details = response
      const isBannerImageExists = this.details?.merchantDetails?.merchantLogo
      if (isBannerImageExists) {
        this.bannerImage = isBannerImageExists
      } else {
        this.bannerImage = this.bannerImage
      }
      this.md = this.details.merchantDetails
      this.id = this.details.invoiceDetails
      this.cd = this.details.consumerDetails
      this.td = this.details.txDetails
      this.shippingFee = parseInt(this.id.items.shippingFee)
      const lineitems = getL2L3LineItemDetails(this.id.items.itemsList)


      for (let i = 0; i < lineitems.length; i++) {
        handleLineItemEmptyValues(lineitems[i].lineItemData)
      }

      const { lineItemsArray, totalDiscount, totalTax } = getLineItemDetails(lineitems)
      this.totalAmount = this.id.amount || 0;
      this.lineItemDetails = lineItemsArray
      // this.totalAmount = (this.td?.approvedAmount ? this.td.approvedAmount : (this.shippingFee ? totalAmount + this.shippingFee : totalAmount))
      this.totalDiscount = totalDiscount
      this.totalTax = totalTax
      const childInvoices = this.details?.childInvoices || []
      console.log(childInvoices);
      if(this.details.invoiceDetails.invoiceType === 'ItemizedBilling'&&this.details.invoiceDetails.status === 'Partially Paid'){
      this.paidChildInvoicesTotal = childInvoices
        .filter((c) => c.status === 'Success')
        .reduce((sum, c) => sum + (typeof c.amount === 'string' ? parseInt(c.amount, 10) || 0 : c.amount || 0), 0)
        console.log(this.paidChildInvoicesTotal);
        console.log("-------------------------------------00000");
      }
    }
    catch (err) {
      if (this.isOpenUrl) {
        const msgbj = { icon: "notify.svg", message: err.message };
        this.router.navigateByUrl(`/message/${window.btoa(JSON.stringify(msgbj))}`);
      } else {
        this.messageService.add({
          severity: "error",
          detail: err.message || "Server Error !",
          sticky: true
        });
      }
    }
    this.isLoading = false
  }


  download(type) {
    html2canvas(this.invoiceRef.nativeElement,
      { scrollY: 0, allowTaint: true, useCORS: true, logging: true }).then((canvas) => {
        let a = document.createElement("a");
        let x = new Date().toLocaleString();
        if (type == 'png') {
          this.pngDownload(a, canvas.toDataURL('image/png'), `${this.invoiceId}.png`);
        } else {
          window.print()
        }
      });
  }

  pngDownload(a, img, fileName) {
    a.href = img;
    a.download = fileName;
    a.webkitImageSmoothingEnabled = false;
    a.mozImageSmoothingEnabled = false;
    a.imageSmoothingEnabled = false
    a.click();
  }

  pdfDownload(imgData, fileName) {
    const doc = new jsPDF("p", "mm", "a4");

    const width = doc.internal.pageSize.getWidth()
    const height = doc.internal.pageSize.getHeight()
    // By Adding 'FAST' we can reduce the pdf size.
    doc.addImage(imgData, 'PNG', 0, 0, width, height, '', 'FAST');
    doc.save(fileName);
    // window.open(doc.output(this.bloburl, { filename: fileName }), '_blank')
  }



}
